import {
  getFrontNotifiche,
  getGetFrontNotificheQueryKey,
  useGetFrontNotifiche,
  usePostFrontNotificheIdPresaVisione,
} from '@framework/api-client';
import {
  INotificationsContext,
  NotificationsContextProvider,
} from '@framework/common-web';
import React from 'react';
import { NotificationsButton } from './NotificationsButton';

export interface IFrontNotificationButtonProps {}

export function FrontNotificationButton(props: IFrontNotificationButtonProps) {
  // const {} = props;
  const contextValue: INotificationsContext = {
    useGetNotifications: useGetFrontNotifiche,
    useMarkAsRead: usePostFrontNotificheIdPresaVisione,
    getGetNotificationsQueryKey: getGetFrontNotificheQueryKey,
    getNotifications: getFrontNotifiche,
  };

  return (
    <NotificationsContextProvider {...contextValue}>
      <NotificationsButton />
    </NotificationsContextProvider>
  );
}
